import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { get } from '../../../lib/api';
import { setShelfTiles } from '../../../lib/redux/campaignDnd/campaignDndSlice';

export const useFetchShelfTiles = ({ forceRefetch = false }) => {
  const dispatch = useDispatch();
  const { data, refetch } = useQuery(
    ['shelfTiles'],
    () => get('/api/client_admin/campaigns/shelf_tiles'),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    dispatch(setShelfTiles(data));
  }, [data, dispatch]);

  useEffect(() => {
    if (forceRefetch) {
      refetch();
    }
  }, [forceRefetch]);
};
